/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IOrganization } from "../../models/Organizations/OrganizationContracts";
import {
  SET_NO_ORGANIZATION,
  GET_ALL_ORGANIZATIONS,
  GET_ORGANIZATIONS_LIST,
  SET_SELECTED_ORGANIZATION,
  SET_FILTERED_ORGANIZATIONS,
  GET_APPLICATIONS_FOR_ORGANIZATION,
  SET_PAGINATION_ORG,
} from "./types";
import { IApplication } from "../../models/Organizations/Application";

export const getAllOrganizationsAction = (
  organizations: IOrganization[],
  selectedOrganization: IOrganization,
  noOrganization: boolean
) => {
  return {
    type: GET_ALL_ORGANIZATIONS,
    organizations: organizations,
    selectedOrganization,
    noOrganization,
  };
};

export const getOrganizationsListAction = (organizations: IOrganization[]) => {
  return {
    type: GET_ORGANIZATIONS_LIST,
    organizations: organizations,
  };
};

export const setFilteredOrganizationAction = (
  filteredOrganizations: IOrganization[]
) => {
  return {
    type: SET_FILTERED_ORGANIZATIONS,
    filteredOrganizations: filteredOrganizations,
  };
};

export const getApplicationsForOrganizationAction = (
  applicationsForOrganization: IApplication[]
) => {
  return {
    type: GET_APPLICATIONS_FOR_ORGANIZATION,
    applicationsForOrganization: applicationsForOrganization,
  };
};

export const setSelectedOrganizationAction = (selectedOrganization: IOrganization | object) => {
  return {
    type: SET_SELECTED_ORGANIZATION,
    selectedOrganization,
  };
};

export const setNoOrganizationAction = (noOrganization: boolean) => {
  return {
    type: SET_NO_ORGANIZATION,
    noOrganization,
  };
};

export const setOrgPaginationAction = (pagination: any) => {
  return {
    type: SET_PAGINATION_ORG,
    pagination,
  };
}